if (!customElements.get("color-swatch")) {
  class ColorSwatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.optionNodes = this.querySelectorAll("[data-value]");
      this.init();
    }

    disconnectedCallback() {
      this.optionNodes.forEach((button) => {
        button.removeEventListener("mouseenter", this.onMouseEnterBound);
        button.removeEventListener("click", this.onClickBound);
      });
    }

    init() {
      const productCard = this.closest(".product-card");
      this.mainImage = productCard.querySelector(
        ".product-card__image--main img"
      );

      // Clicking/tapping a swatch only previews the product-card image and keeps
      // the user on the PLP, on both desktop and touch devices. Desktop hover
      // still previews, and PDP navigation stays available via the product-card
      // image/title link and the "+N more" overflow swatch.
      this.onMouseEnterBound = this.onMouseEnter.bind(this);
      this.onClickBound = this.onClick.bind(this);

      this.optionNodes.forEach((button) => {
        button.addEventListener("mouseenter", this.onMouseEnterBound);
        button.addEventListener("click", this.onClickBound);
      });

      this.selected = this.querySelector('a[aria-selected="true"]');

      this.getVariantData();
      this.initOptionSwatches();
    }

    initOptionSwatches() {
      this.optionNodes.forEach((optNode) => {
        let variantImage;
        const { optionPosition, value: optionValue } = optNode.dataset;
        const variant = this.variantData.find(
          (v) =>
            v[`option${optionPosition}`] &&
            v[`option${optionPosition}`].toLowerCase() ===
              optionValue.toLowerCase()
        );
        if (variant) {
          variantImage = variant.featured_image
            ? variant.featured_image.src
            : "";
          optNode.href = `${optNode.href}?variant=${variant.id}`;
          if (variantImage) {
            optNode.setAttribute(
              "data-src",
              getSizedImageUrl(variantImage, "900x")
            );
            optNode.setAttribute("data-srcset", getSrcset(variantImage));
          }
        }
      });
    }

    preview(node) {
      this.selected && this.selected.removeAttribute("aria-selected");
      node.setAttribute("aria-selected", true);

      const { src, srcset } = node.dataset;
      if (this.mainImage && srcset) {
        this.mainImage.src = src;
        this.mainImage.srcset = srcset;
      }

      this.selected = node;
    }

    onMouseEnter(e) {
      this.preview(e.target);
    }

    onClick(e) {
      // Swatch clicks preview the card image instead of opening the PDP.
      e.preventDefault();
      this.preview(e.currentTarget);
    }

    getVariantData() {
      this.variantData =
        this.variantData || JSON.parse(this.nextElementSibling.textContent);
    }
  }
  customElements.define("color-swatch", ColorSwatch);
}
